import React, { createContext, useContext } from 'react';
import { UUID } from '@/types';

const SeriesIdContext = createContext('' as UUID);

export const useSeriesIdContext = () => useContext(SeriesIdContext);

export const SeriesIdContextProvider: React.FC<any> = ({
  seriesId,
  children,
}) => (
  <SeriesIdContext.Provider value={seriesId}>
    {children}
  </SeriesIdContext.Provider>
);
